"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Notification(_ref) {
  var onReset = _ref.onReset;

  try {
    var handleResetState = function handleResetState() {
      onReset();
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'payout.dialog.notification'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-i')
    }), /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 3,
      className: _defaultModule["default"]['header']
    }, "\u0420\u0435\u0435\u0441\u0442\u0440 \u0441 \u0442\u0430\u043A\u0438\u043C\u0438 \u043D\u0430\u0431\u043E\u0440\u043E\u043C \u0434\u0430\u043D\u043D\u044B\u0445", /*#__PURE__*/_react["default"].createElement("br", null), "\u0431\u044B\u043B \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D \u0440\u0430\u043D\u0435\u0435"), /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      className: _defaultModule["default"]['text']
    }, "\u0415\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u043E\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u0440\u0435\u0435\u0441\u0442\u0440\u0443 \u0435\u0449\u0435 \u0440\u0430\u0437, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\xBB"), /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
      onReset: handleResetState
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Notification;
exports["default"] = _default;